module.exports = "<div id=\"hide-menu\" class=\"btn-header pull-right\">\n        <span> <a (click)=\"onToggle()\" title=\"Collapse Menu\"><i\n                class=\"fa fa-reorder\"></i></a> </span>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/header/collapse-menu/collapse-menu.component.html
// module id = ../../../../../src/app/shared/layout/header/collapse-menu/collapse-menu.component.html
// module chunks = main